export const venuePhotos = {
  rockwood: {
    main: '/photos/webp/sm23-rockwood5.webp',
    alt: 'Daryian Kelton performing at Rockwood Music Hall'
  },
  ironcow: {
    first: '/photos/webp/sm23-ironcow1.webp',
    third: '/photos/webp/sm23-ironcow3.webp',
    alt: 'Daryian Kelton at Iron Cow'
  },
  smiths: {
    main: '/photos/webp/sm23-smithbar1.webp',
    alt27: '/photos/webp/sm23-smithbar27.webp',
    alt29: '/photos/webp/sm23-smithbar29.webp',
    alt: 'Daryian Kelton performing at Smiths Bar'
  },
  milestone: {
    first: '/photos/webp/sm23-milestone1.webp',
    second: '/photos/webp/sm23-milestone2.webp',
    alt: 'Daryian Kelton at The Milestone'
  }
}; 